'use client'

import React from 'react'

import { CardDocuments as normalizeCardDocuments } from '../../../../models'
import { CardNews as normalizeCardNews } from '../../../../models'


import CardDocuments from '../../CardDocuments/CardDocuments.component'
import CardNews from '../../CardNews/CardNews.component'
import CardSquare from '../../CardSquare/CardSquare.component'


const AlgoliaSearchHit = ({ hit, entity }) => {
  const dispatcher = {
    news: {
      component: CardNews,
      normalizer: normalizeCardNews
    },
    document: {
      component: CardDocuments,
      normalizer: normalizeCardDocuments
    },
    page: {
      component: (props) => {
        const { title, slug, featuredImage, locale } = props
        const image = 'https://picsum.photos/600'
        const alt = 'Image'
        const pageSlug = slug.split('-').slice(1).join('-')

        return (
          <CardSquare
            parentColorScheme={'green'}
            withBackground={false}
            title={title}
            href={`/${locale}/${pageSlug}`}
            image={{
              url: featuredImage ? featuredImage.url : image,
              alt: featuredImage ? featuredImage.alternativeText : alt
            }}
          />
        )
      },
      normalizer: (obj) => obj
    },
  }

  const Component = dispatcher[entity]

  const normalizedData = Component ? Component.normalizer(hit) : null

  return Component?.component ? (
    <Component.component {...normalizedData} />
  ) : null
}

export default AlgoliaSearchHit
